<div class="container modern-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-briefcase"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Training & Placement Cell</h2>
        <p class="page-subtitle">Bridging education and career opportunities for pharmacy students</p>
      </div>
    </div>
  </div>

  <div class="card modern-card shadow-lg">
    <div class="card-body">
      <h5 class="card-title">
        <i class="fas fa-file-alt me-2"></i>Placement Documents & Resources
      </h5>
      <hr class="title-divider">

      <div class="row">
        <div class="col-lg-12">
          <ul class="list-group modern-list">
            <li class="list-group-item modern-item" *ngFor="let link of tnpList; let i=index">
              <div class="item-wrapper">
                <div class="item-icon">
                  <i class="fas fa-file-pdf"></i>
                  <span class="item-number">{{i + 1}}</span>
                </div>
                <div class="item-content">
                  <a [href]="link.filename" target="_blank" class="item-link">
                    {{link.displayText}}
                  </a>
                  <span class="item-meta">
                    <i class="fas fa-download"></i> Click to view or download
                  </span>
                </div>
                <div class="item-actions">
                  <button class="btn btn-sm btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#placementModal'+i">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Training & Placement Info Section -->
  <div class="row mt-4 info-section">
    <div class="col-md-6 mb-3">
      <div class="info-card">
        <div class="info-icon bg-admission">
          <i class="fas fa-bullseye"></i>
        </div>
        <h5>Our Mission</h5>
        <p>To provide comprehensive training and placement support to help pharmacy students build successful careers in pharmaceutical industry and healthcare sector.</p>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="info-card">
        <div class="info-icon bg-eligibility">
          <i class="fas fa-handshake"></i>
        </div>
        <h5>Industry Connect</h5>
        <p>Strong partnerships with pharmaceutical companies, hospitals, and research organizations for internships and placement opportunities.</p>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="info-card">
        <div class="info-icon bg-dates">
          <i class="fas fa-chalkboard-teacher"></i>
        </div>
        <h5>Training Programs</h5>
        <p>Soft skills, interview preparation, aptitude training, and personality development workshops.</p>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="info-card">
        <div class="info-icon bg-admission">
          <i class="fas fa-building"></i>
        </div>
        <h5>Campus Placements</h5>
        <p>Regular campus recruitment drives with leading pharmaceutical companies and healthcare organizations.</p>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="info-card">
        <div class="info-icon bg-eligibility">
          <i class="fas fa-user-graduate"></i>
        </div>
        <h5>Career Guidance</h5>
        <p>One-on-one counseling, career path planning, and guidance for higher studies and entrepreneurship.</p>
      </div>
    </div>
  </div>

  <!-- Placement Statistics -->
<!--   <div class="card modern-card shadow-lg mt-4">
    <div class="card-body">
      <h5 class="card-title">
        <i class="fas fa-chart-line me-2"></i>Placement Highlights
      </h5>
      <hr class="title-divider">
      <div class="row text-center">
        <div class="col-md-3 mb-3">
          <div class="stat-box">
            <i class="fas fa-users stat-icon"></i>
            <h3 class="stat-number">95%+</h3>
            <p class="stat-label">Placement Rate</p>
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="stat-box">
            <i class="fas fa-building stat-icon"></i>
            <h3 class="stat-number">50+</h3>
            <p class="stat-label">Recruiting Companies</p>
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="stat-box">
            <i class="fas fa-rupee-sign stat-icon"></i>
            <h3 class="stat-number">₹2.5L+</h3>
            <p class="stat-label">Average Package</p>
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="stat-box">
            <i class="fas fa-star stat-icon"></i>
            <h3 class="stat-number">₹5L+</h3>
            <p class="stat-label">Highest Package</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>

<!-- PDF Viewer Modals - Outside container for proper z-index -->
<ng-container *ngFor="let link of tnpList; let i=index">
  <app-pdf-viewer [title]="link.displayText" [url]="link.filename" [id]="'placementModal'+i" [hideButton]="true"></app-pdf-viewer>
</ng-container>